import React, { useState } from "react";
import {
    Button,
    Card,
    Flex,
    Form,
    Input,
    Select,
    Table,
    Upload,
    message,
} from "antd";
import { FileExcelOutlined, InboxOutlined } from "@ant-design/icons";
import axios from "axios";

import Apiurl from "../ConstURL";
import Header from "../components/Header";

export default function Addtask() {
    const [form] = Form.useForm();

    const [FindedList, setFindedList] = useState([]);
    const [Loading, setLoading] = useState(false);
    const [SearchParam, setSearchParam] = useState("");

    const columns = [
        { title: "Id", dataIndex: "id", key: "id" },
        { title: "Zoro_sku", dataIndex: "Zoro_sku", key: "Zoro_sku" },
        { title: "seller-sku", dataIndex: "seller-sku", key: "seller-sku" },
        { title: "asin1", dataIndex: "asin1", key: "asin1" },
        { title: "item-name", dataIndex: "item-name", key: "item-name" },
        { title: "price", dataIndex: "price", key: "price" },
        { title: "quantity", dataIndex: "quantity", key: "quantity" },
        { title: "status", dataIndex: "status", key: "status" },
        {
            title: "minimum-seller-allowed-price",
            dataIndex: "minimum-seller-allowed-price",
            key: "minimum-seller-allowed-price",
        },
        {
            title: "maximum-seller-allowed-price",
            dataIndex: "maximum-seller-allowed-price",
            key: "maximum-seller-allowed-price",
        },
        // Если backend уже возвращает поле:
        { title: "filename", dataIndex: "filename", key: "filename" },
    ];

    const unique = (arr) => Array.from(new Set(arr));

    const parseTokens = (text) => {
        return unique(
            (text || "")
                .split(/[\s,;]+/g) // пробел, enter, tab, запятая, ;
                .map((v) => v.trim())
                .filter(Boolean)
        );
    };

    const normalizeSelectValues = (values) => {
        if (!values) return [];
        if (Array.isArray(values)) return parseTokens(values.join(" "));
        return parseTokens(String(values));
    };

    const appendToFormField = (fieldName, items) => {
        const current = form.getFieldValue(fieldName) || [];
        const merged = unique([...(Array.isArray(current) ? current : []), ...items]);
        form.setFieldsValue({ [fieldName]: merged });
    };

    const handleTxtUpload = (fieldName) => async (file) => {
        try {
            const text = await file.text();
            const parsed = parseTokens(text);
            if (parsed.length === 0) {
                message.warning("В файле не найдено значений");
                return Upload.LIST_IGNORE;
            }
            appendToFormField(fieldName, parsed);
            message.success(`Добавлено ${parsed.length} значений из ${file.name}`);
        } catch (e) {
            console.error(e);
            message.error("Не удалось прочитать TXT файл");
        }
        return Upload.LIST_IGNORE; // не грузим файл на сервер
    };

    const Sendrequest = async (values) => {
        const skuList = normalizeSelectValues(values.skuList);
        const asinList = normalizeSelectValues(values.asinList);

        // Поддержка старых одиночных полей (если заполнены)
        if (values.sku) skuList.push(...parseTokens(values.sku));
        if (values.asin) asinList.push(...parseTokens(values.asin));

        const finalSkuList = unique(skuList);
        const finalAsinList = unique(asinList);

        if (finalSkuList.length === 0 && finalAsinList.length === 0) {
            message.warning("Добавьте хотя бы один SKU или ASIN");
            return;
        }

        setLoading(true);
        try {
            const token = localStorage.getItem("token") || "";

            // Новый формат: массивы в JSON body
            const res = await axios.post(
                `${Apiurl}/function2?token=${encodeURIComponent(token)}`,
                {
                    search: finalSkuList,
                    asins: finalAsinList,
                }
            );

            if (res && res.data && res.data.Status) {
                const data = Array.isArray(res.data.Data) ? res.data.Data : [];
                const withIds = data.map((item, index) => ({
                    ...item,
                    id: index + 1,
                }));

                setFindedList(withIds);
                setSearchParam(finalSkuList.join(" "));
            } else {
                message.error("Ошибка");
            }
        } catch (err) {
            console.error(err);
            message.error("Ошибка запроса");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <Header />
            <Flex justify="center" style={{ paddingTop: "25px" }}>
                <Card style={{ width: "95vw" }} title="Поиск дублей">
                    <Form
                        layout="vertical"
                        name="search-form"
                        form={form}
                        initialValues={{ skuList: [], asinList: [] }}
                        onFinish={Sendrequest}
                        autoComplete="off"
                    >
                        <Flex gap={1} vertical={true} >
                            <Form.Item
                                label="SKU"
                                name="skuList"
                                style={{ minWidth: 380, flex: 1 }}
                                extra="Вставляйте список через пробел, Enter, tab, запятую или ;"
                            >
                                <Select
                                    mode="tags"
                                    placeholder="Например: G12345 G67890 (или с новой строки)"
                                    tokenSeparators={[" ", "\n", "\t", ",", ";"]}
                                    open={false}
                                />
                            </Form.Item>

                            <Upload
                                accept=".txt,text/plain"
                                showUploadList={false}
                                beforeUpload={handleTxtUpload("skuList")}
                            >
                                <Button icon={<InboxOutlined />}>Загрузить SKU из TXT</Button>
                            </Upload>
                        </Flex>

                        <Flex gap={1} vertical={true} style={{marginTop:20}}>
                            <Form.Item
                                label="ASIN"
                                name="asinList"
                                style={{ minWidth: 380, flex: 1 }}
                                extra="Также поддерживается вставка через пробел/Enter"
                            >
                                <Select
                                    mode="tags"
                                    placeholder="Например: B0XXXXXXX B0YYYYYYY"
                                    tokenSeparators={[" ", "\n", "\t", ",", ";"]}
                                    open={false}
                                />
                            </Form.Item>

                            <Upload
                                accept=".txt,text/plain"
                                showUploadList={false}
                                beforeUpload={handleTxtUpload("asinList")}
                            >
                                <Button icon={<InboxOutlined />}>Загрузить ASIN из TXT</Button>
                            </Upload>
                        </Flex>

                        {/* Сохранены старые поля (можешь убрать, если не нужны) */}
                        {/*<Flex gap={12} wrap="wrap">*/}
                        {/*    <Form.Item label="SKU (одиночный, опц.)" name="sku">*/}
                        {/*        <Input placeholder="если нужен старый формат" />*/}
                        {/*    </Form.Item>*/}
                        {/*    <Form.Item label="ASIN (одиночный, опц.)" name="asin">*/}
                        {/*        <Input placeholder="если нужен старый формат" />*/}
                        {/*    </Form.Item>*/}
                        {/*</Flex>*/}

                        <Form.Item>
                            <Button style={{marginTop:25}}  type="primary" htmlType="submit" size="large" loading={Loading}>
                                Поиск
                            </Button>
                        </Form.Item>
                    </Form>

                    {FindedList.length > 0 && SearchParam ? (
                        <Button
                            rel="noreferrer"
                            target="_blank"
                            href={`${Apiurl}/function2/getfile?search=${encodeURIComponent(
                                SearchParam
                            )}&token=${encodeURIComponent(localStorage.getItem("token") || "")}`}
                            download="test.xlsx"
                            type="primary"
                            size="large"
                            icon={<FileExcelOutlined />}
                            style={{ marginTop: 8 }}
                        >
                            Скачать
                        </Button>
                    ) : null}

                    <Table
                        style={{ paddingTop: "25px" }}
                        loading={Loading}
                        columns={columns}
                        dataSource={FindedList}
                        rowKey={(record) => record.id}
                        pagination={{
                            showSizeChanger: true,
                            showTotal: () => `Найдено ${FindedList.length}`,
                            position: ["bottomCenter"],
                            pageSizeOptions: [10, 20, 30, 40, 50, 100],
                        }}
                    />
                </Card>
            </Flex>
        </div>
    );
}
